import { Component, inject } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { InvoiceDueStatus, getInvoiceDueStatus } from './invoice-due-status.util';
import { Invoice } from '../../../../models/invoice-model';
import { AppFacadeService } from '../../../../services/app-facade.service';

@Component({
    standalone: false,
    selector: 'por-invoice-number-cell-renderer',
    templateUrl: './invoice-number-cell-renderer.component.html',
    styleUrls: ['./invoice-number-cell-renderer.component.scss']
})
export class InvoiceNumberCellRendererComponent implements ICellRendererAngularComp {
    private readonly appFacadeService = inject(AppFacadeService);

    status: InvoiceDueStatus = null;
    invoiceNumber: string | number | undefined;

    get canSeeInvoiceDetails(): boolean {
        return this.appFacadeService.featureToggleService.isAvailable('canSeeInvoiceDetails');
    }

    agInit(params: ICellRendererParams): void {
        this.setState(params);
    }

    refresh(params: ICellRendererParams): boolean {
        this.setState(params);
        return true;
    }

    private setState(params: ICellRendererParams): void {
        this.status = getInvoiceDueStatus((params.data as Invoice | undefined)?.DueDate, (params.data as Invoice | undefined)?.AmountDue);
        this.invoiceNumber = params.value as string | number | undefined;
    }
}
